import { playUiClick } from "../audio/sfx";
import { PARCHMENT, DANGER } from "./theme";
// A checkbox styled as an iOS-style switch, wrapped together with its row label in a single
// <label> so native label semantics make the whole row clickable (not just the small knob),
// and the row gets the pointer cursor consistent with the rest of the game's clickable elements.
export function createSwitchRow(labelText, initial, onChange, title, required = false) {
    const row = document.createElement("label");
    row.style.cssText =
        "display: flex; align-items: center; justify-content: space-between; gap: 10px; cursor: pointer;";
    if (title)
        row.title = title;
    const text = document.createElement("span");
    text.style.cssText = "font-size: 13px;";
    text.textContent = labelText;
    if (required) {
        const star = document.createElement("span");
        star.style.cssText = `color: ${DANGER}; margin-left: 3px;`;
        star.textContent = "*";
        text.appendChild(star);
    }
    const switchEl = document.createElement("span");
    switchEl.style.cssText =
        "position: relative; display: inline-block; width: 36px; height: 20px; flex-shrink: 0;";
    const input = document.createElement("input");
    input.type = "checkbox";
    input.checked = initial;
    input.style.cssText = "position: absolute; opacity: 0; width: 0; height: 0;";
    const track = document.createElement("span");
    track.style.cssText =
        "position: absolute; inset: 0; border-radius: 10px; transition: background 0.15s;";
    const knob = document.createElement("span");
    knob.style.cssText = `
    position: absolute;
    top: 2px; left: 2px;
    width: 16px; height: 16px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0,0,0,0.3);
    transition: transform 0.15s;
  `;
    const render = () => {
        track.style.background = input.checked
            ? PARCHMENT.highlightBorder
            : PARCHMENT.divider;
        knob.style.transform = input.checked ? "translateX(16px)" : "translateX(0)";
    };
    render();
    input.addEventListener("change", () => {
        playUiClick();
        render();
        onChange(input.checked);
    });
    switchEl.append(input, track, knob);
    row.append(text, switchEl);
    return {
        row,
        setChecked: (checked) => {
            input.checked = checked;
            render();
        },
    };
}
